<template>
	<section>
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
				<el-form-item>
					<el-button type="primary" @click.native="editSubmit" :loading="editLoading">保存</el-button>
				</el-form-item>
				<el-form-item label="Js脚本" prop="js_data">
					<el-tag>
					{{editForm.md5str}}
					</el-tag>
				</el-form-item>
				<el-form-item label="脚本信息" prop="js_data">
					<el-input type="textarea" :rows="25" placeholder="请输入内容" v-model="editForm.js_data"></el-input>
				</el-form-item>
			</el-form>
		</el-col>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	//import NProgress from 'nprogress'
	import { getListPage, delData, saveData,postData,save } from '../../api/api';

	export default {
		data() {
			return {
				formRules: {
					jsonstr: [
						{
							required: true,message: '配置信息不能为空',trigger: 'blur'
						}
					]
				},
				//编辑界面数据
				editForm: {
					js_data :'',
					actionurl:'datas/setJsStr',
				}
			}
		},
		methods: {
			//获取用户列表
			getConfData() {
				let para = {
					actionurl:'datas/getJs',
				};
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						try {
							this.editForm.js_data = JSON.stringify(res.data.jsdata, null, 4);
						}catch(err) {}
					}
				});
			},
			//编辑保存
			editSubmit: function () {
				let param = Object.assign({}, this.editForm);
			
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							save(param).then((res) => {
								this.$message({
									message: res.data.message,
									type: res.data.type
								});
								if(res.data.type=='success'){
									this.getConfData();
								}
							});
						}).catch((e) => {
							console.log("异常:"+e.message);
						});
					}
				});
				//this.$message({
				//	type: 'error',message: '暂不能更改'
				//});
			}
		},
		mounted() {
			this.getConfData();
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// jsConf.vue?63f47d97